export enum PillType {
  Primary,
  Error,
  Info,
  Warning,
  Success,
}
